'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Name component used to get the user's full name
 * - used with account creation
 * - depends on VX and the grid
 */

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

var Name = _react2.default.createClass({
	displayName: 'Name',

	propTypes: {
		firstNameLabel: _react.PropTypes.string.isRequired,
		lastNameLabel: _react.PropTypes.string.isRequired,
		required: _react.PropTypes.bool,
		firstNameDefaultValue: _react.PropTypes.string,
		lastNameDefaultValue: _react.PropTypes.string,
		firstNameErrorMessage: _react.PropTypes.string,
		lastNameErrorMessage: _react.PropTypes.string,
		handleChangeFirstName: _react.PropTypes.func.isRequired,
		handleChangeLastName: _react.PropTypes.func.isRequired,
		handleFocusFirstName: _react.PropTypes.func,
		handleFocusLastName: _react.PropTypes.func,
		handleBlurFirstName: _react.PropTypes.func,
		handleBlurLastName: _react.PropTypes.func
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleFocusFirstName: function handleFocusFirstName() {},
			handleFocusLastName: function handleFocusLastName() {},
			handleBlurFirstName: function handleBlurFirstName() {},
			handleBlurLastName: function handleBlurLastName() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			showFirstNameIsRequiredError: false,
			showLastNameIsRequiredError: false
		};
	},


	/**
  * Check for a first name value if it's required
  * @param {String} name - first name
  */
	handleCheckFirstNameValue: function handleCheckFirstNameValue(name) {
		this.setState({ showFirstNameIsRequiredError: this.props.required && !name });
	},


	/**
  * Check for a last name value if it's required
  * @param {String} name - last name
  */
	handleCheckLastNameValue: function handleCheckLastNameValue(name) {
		this.setState({ showLastNameIsRequiredError: this.props.required && !name });
	},
	handleChangeFirstName: function handleChangeFirstName(firstName) {
		this.handleCheckFirstNameValue(firstName);
		this.props.handleChangeFirstName(firstName);
		return firstName;
	},
	handleChangeLastName: function handleChangeLastName(lastName) {
		this.handleCheckLastNameValue(lastName);
		this.props.handleChangeLastName(lastName);
		return lastName;
	},
	handleBlurFirstName: function handleBlurFirstName(firstName) {
		this.handleCheckFirstNameValue(firstName);
		this.props.handleBlurFirstName(firstName);
	},
	handleBlurLastName: function handleBlurLastName(lastName) {
		this.handleCheckLastNameValue(lastName);
		this.props.handleBlurLastName(lastName);
	},
	render: function render() {
		var _this = this;

		var _props = this.props,
		    firstNameErrorMessage = _props.firstNameErrorMessage,
		    lastNameErrorMessage = _props.lastNameErrorMessage;

		// define the wrapper classNames, which handle showing error messages

		var firstNameWrapperClassNames = (0, _classnames2.default)('col-md-6', {
			'vx_has-error-with-message': firstNameErrorMessage,
			'vx_has-error': !firstNameErrorMessage && this.state.showFirstNameIsRequiredError
		});
		var lastNameWrapperClassNames = (0, _classnames2.default)('col-md-6', {
			'vx_has-error-with-message': lastNameErrorMessage,
			'vx_has-error': !lastNameErrorMessage && this.state.showLastNameIsRequiredError
		});

		return _react2.default.createElement(
			'div',
			{ className: 'row' },
			_react2.default.createElement(
				'div',
				{ className: firstNameWrapperClassNames, style: { margin: '10px 0' } },
				_react2.default.createElement(_reactTextInput2.default, {
					name: 'firstName',
					id: 'firstName',
					className: 'vx_form-control vx_form-control_complex',
					label: this.props.firstNameLabel,
					required: this.props.required,
					value: this.props.firstNameDefaultValue,
					handleChange: this.handleChangeFirstName,
					handleFocus: function handleFocus(firstName) {
						return _this.props.handleFocusFirstName(firstName);
					},
					handleBlur: this.handleBlurFirstName
				}),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, firstNameErrorMessage && styles.errorShown), {
							'vx_form-control-message': firstNameErrorMessage
						}) },
					firstNameErrorMessage
				)
			),
			_react2.default.createElement(
				'div',
				{ className: lastNameWrapperClassNames, style: { margin: '10px 0' } },
				_react2.default.createElement(_reactTextInput2.default, {
					name: 'lastName',
					id: 'lastName',
					className: 'vx_form-control vx_form-control_complex',
					label: this.props.lastNameLabel,
					required: this.props.required,
					value: this.props.lastNameDefaultValue,
					handleChange: this.handleChangeLastName,
					handleFocus: function handleFocus(lastName) {
						return _this.props.handleFocusLastName(lastName);
					},
					handleBlur: this.handleBlurLastName
				}),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, lastNameErrorMessage && styles.errorShown), {
							'vx_form-control-message': lastNameErrorMessage
						}) },
					lastNameErrorMessage
				)
			)
		);
	}
});

exports.default = Name;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Name.js
// module id = 546
// module chunks = 4